const PIN_SALT = 'garderie-schedule-v1';

/** Deterministic PIN hash for local MVP (replace with server-side bcrypt in production). */
export function hashPin(pin: string): string {
  const normalized = pin.trim();
  const s = `${PIN_SALT}:${normalized}`;
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = (h * 33) ^ s.charCodeAt(i);
  }
  return `h${(h >>> 0).toString(16)}`;
}

export function verifyPin(pin: string, pinHash: string): boolean {
  return hashPin(pin) === pinHash;
}

export function isValidPin(pin: string): boolean {
  return /^\d{4}$/.test(pin.trim());
}
